import axios from 'axios';

class ConfigServiceClass {
    public configUrl = '/env_config.json';
    public config: any = {};

    public async fetchConfig(): Promise<any> {
        const response = await axios.get(this.configUrl);
        this.config = response.data;
        return this.config;
    }
}

const ConfigService = new ConfigServiceClass();

export default ConfigService;
